/* eslint-disable max-len */
import { useContext, useEffect } from 'react';
import { RouteObject } from 'react-router-dom';

import { TabRouteObject } from '../../../hooks';
import { Breadcrumb, BreadcrumbsContext } from '../BreadcrumbsContext';

export const normalizePath = (path?: string): string => (path || '').replace('*', '');
export const trimLastSlash = (path: string): string => path.replace(/\/$/, '');

export type BreadcrumbedRouteObject = RouteObject & { label?: string };

type RouteUnion = BreadcrumbedRouteObject | TabRouteObject

const filterPaths = (routes: RouteUnion[], breadcrumbs: Breadcrumb[], parentPath: string): Breadcrumb[] => breadcrumbs.filter(({ parentPath: parentPathToFind, uniquePath: pathToFind }) => !routes.some(({ path }) => path === pathToFind && parentPath === parentPathToFind));

export const useRegisterPaths = (routes: RouteUnion[], parentPath: string): void => {
  const { setBreadcrumbs } = useContext(BreadcrumbsContext);
  if (setBreadcrumbs === undefined) {
    throw new Error(
      'Error: Component has to be wrapped with BreadcrumbsProvider',
    );
  }
  useEffect(() => {
    const toSet: Breadcrumb[] = routes.map(({ label, path, index }) => ({
      label,
      path: trimLastSlash(normalizePath(path)),
      uniquePath: path,
      parentPath,
      index,
    }));
    setBreadcrumbs((prev) => ([
      ...filterPaths(routes, prev, parentPath),
      ...toSet,
    ]));
    return () => {
      setBreadcrumbs((prev) => filterPaths(routes, prev, parentPath));
    };
  }, [routes]);
};
